import React, { useState, useEffect } from "react";
// import { gsap, TweenLite } from "gsap";

import gsap from "gsap";
import { Draggable } from "gsap/Draggable";
import { InertiaPlugin } from "gsap/InertiaPlugin";


const Slider = (props) => {
  const [images, setImages] = useState(props.images?props.images:[])
  useEffect(() => {
    gsap.registerPlugin(Draggable, InertiaPlugin);

    var slideDelay = 1.5;
    var slideDuration = 0.3;
    var wrap = true;

    var slides = document.querySelectorAll(".slide");
    var prevButton = document.querySelector("#prevButton");
    var nextButton = document.querySelector("#nextButton");
    var progressWrap = gsap.utils.wrap(0, 1);

    var numSlides = slides.length;

    gsap.set(slides, {
      // backgroundColor: "random([red, blue, green, purple, orange, yellow, lime, pink])",
      color: "#000",
      xPercent: i => i * 100
    });

    var wrapX = gsap.utils.wrap(-100, (numSlides - 1) * 100);
    var timer = gsap.delayedCall(slideDelay, autoPlay);

    var animation = gsap.to(slides, {
      xPercent: "+=" + (numSlides * 100),
      duration: 1,
      ease: "none",
      paused: true,
      repeat: -1,
      modifiers: {
        xPercent: wrapX
      }
    });

    var proxy = document.createElement("div");
    var slideAnimation = gsap.to({}, {});
    var slideWidth = 0;
    var wrapWidth = 0;

    var draggable = new Draggable(proxy, {
      trigger: ".slides-container",
      inertia: true,
      onPress: updateDraggable,
      onDrag: updateProgress,
      onThrowUpdate: updateProgress,
      snap: {
        x: snapX
      }
    });

    resize();

    window.addEventListener("resize", resize);

    prevButton.addEventListener("click", function () {
      animateSlides(1);
    });

    nextButton.addEventListener("click", function () {
      animateSlides(-1);
    });

    function updateDraggable() {
      timer.restart(true);
      slideAnimation.kill();
      this.update();
    }


    function animatetoSlide(index) {

      timer.restart(true);
      slideAnimation.kill();
      var x = snapX(gsap.getProperty(proxy, "x") + direction * slideWidth);
      console.log(x)
      slideAnimation = gsap.to(proxy, {
        x: x,
        duration: slideDuration,
        onUpdate: updateProgress
      });
    }

    function animateSlides(direction) {

      timer.restart(true);
      slideAnimation.kill();
      var x = snapX(gsap.getProperty(proxy, "x") + direction * slideWidth);
      console.log(x)
      slideAnimation = gsap.to(proxy, {
        x: x,
        duration: slideDuration,
        onUpdate: updateProgress
      });
    }

    function autoPlay() {
      if (draggable.isPressed || draggable.isDragging || draggable.isThrowing) {
        timer.restart(true);
      } else {
        // animateSlides(-1);
      }
    }

    function updateProgress() {
      animation.progress(progressWrap(gsap.getProperty(proxy, "x") / wrapWidth));
    }

    function snapX(value) {
      let snapped = gsap.utils.snap(slideWidth, value);
      return wrap ? snapped : gsap.utils.clamp(-slideWidth * (numSlides - 1), 0, snapped);
    }

    function resize() {

      var norm = (gsap.getProperty(proxy, "x") / wrapWidth) || 0;

      slideWidth = slides[0].offsetWidth;
      wrapWidth = slideWidth * numSlides;

      wrap || draggable.applyBounds({ minX: -slideWidth * (numSlides - 1), maxX: 0 });

      gsap.set(proxy, {
        x: norm * wrapWidth
      });

      animateSlides(0);
      slideAnimation.progress(1);
    }


  }, [])

  return (
    <div className="slider">
      <div class="slides-container">
        <div class="slides-inner">
          {
            images.map(image=>{
              return (
                <div class="slide">
                  <img src={image} alt="" />
                </div>
              )
            })
          }
        </div>
      </div>

      <div class="controls custom_controls">
        <span id="prevButton">
          <svg width="56" height="38" viewBox="0 0 56 38" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g filter="url(#filter0_bd_508_4539)">
              <path d="M17.1899 29.6783C17.5645 30.0841 18.1972 30.1094 18.603 29.7348C19.0088 29.3602 19.0341 28.7275 18.6595 28.3217L17.1899 29.6783ZM5.73643 14.3217C5.36183 13.9159 4.72917 13.8906 4.32335 14.2652C3.91753 14.6398 3.89223 15.2724 4.26683 15.6783L5.73643 14.3217ZM4.26683 14.3217C3.89223 14.7276 3.91753 15.3602 4.32335 15.7348C4.72917 16.1094 5.36183 16.0841 5.73643 15.6783L4.26683 14.3217ZM18.6595 1.67828C19.0341 1.27246 19.0088 0.639801 18.603 0.265197C18.1972 -0.109408 17.5645 -0.0841011 17.1899 0.32172L18.6595 1.67828ZM5.00043 14C4.44815 14 4.00043 14.4477 4.00043 15C4.00043 15.5522 4.44815 16 5.00043 16V14ZM50.9492 16C51.5015 16 51.9492 15.5522 51.9492 15C51.9492 14.4477 51.5015 14 50.9492 14V16ZM18.6595 28.3217L5.73643 14.3217L4.26683 15.6783L17.1899 29.6783L18.6595 28.3217ZM5.73643 15.6783L18.6595 1.67828L17.1899 0.32172L4.26683 14.3217L5.73643 15.6783ZM5.00043 16L50.9492 16V14L5.00043 14V16Z" fill="#162434" />
            </g>
            <defs>
              <filter id="filter0_bd_508_4539" x="0" y="-4" width="55.9492" height="42" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                <feFlood flood-opacity="0" result="BackgroundImageFix" />
                <feGaussianBlur in="BackgroundImageFix" stdDeviation="2" />
                <feComposite in2="SourceAlpha" operator="in" result="effect1_backgroundBlur_508_4539" />
                <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                <feOffset dy="4" />
                <feGaussianBlur stdDeviation="2" />
                <feComposite in2="hardAlpha" operator="out" />
                <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
                <feBlend mode="normal" in2="effect1_backgroundBlur_508_4539" result="effect2_dropShadow_508_4539" />
                <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_508_4539" result="shape" />
              </filter>
            </defs>
          </svg>

        </span>
        <span id="nextButton">
          <svg width="56" height="38" viewBox="0 0 56 38" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g filter="url(#filter0_bd_508_4543)">
              <path d="M38.7593 0.32172C38.3847 -0.0841007 37.752 -0.109407 37.3462 0.265197C36.9404 0.6398 36.9151 1.27246 37.2897 1.67828L38.7593 0.32172ZM50.2128 15.6783C50.5874 16.0841 51.22 16.1094 51.6259 15.7348C52.0317 15.3602 52.057 14.7276 51.6824 14.3217L50.2128 15.6783ZM51.6824 15.6783C52.057 15.2724 52.0317 14.6398 51.6259 14.2652C51.22 13.8906 50.5874 13.9159 50.2128 14.3217L51.6824 15.6783ZM37.2897 28.3217C36.9151 28.7275 36.9404 29.3602 37.3462 29.7348C37.752 30.1094 38.3847 30.0841 38.7593 29.6783L37.2897 28.3217ZM50.9488 16C51.5011 16 51.9488 15.5523 51.9488 15C51.9488 14.4478 51.5011 14 50.9488 14V16ZM5 14C4.44772 14 4 14.4478 4 15C4 15.5523 4.44772 16 5 16V14ZM37.2897 1.67828L50.2128 15.6783L51.6824 14.3217L38.7593 0.32172L37.2897 1.67828ZM50.2128 14.3217L37.2897 28.3217L38.7593 29.6783L51.6824 15.6783L50.2128 14.3217ZM50.9488 14L5 14V16H50.9488V14Z" fill="#162434" />
            </g>
            <defs>
              <filter id="filter0_bd_508_4543" x="0" y="-4" width="55.9492" height="42" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                <feFlood flood-opacity="0" result="BackgroundImageFix" />
                <feGaussianBlur in="BackgroundImageFix" stdDeviation="2" />
                <feComposite in2="SourceAlpha" operator="in" result="effect1_backgroundBlur_508_4543" />
                <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                <feOffset dy="4" />
                <feGaussianBlur stdDeviation="2" />
                <feComposite in2="hardAlpha" operator="out" />
                <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
                <feBlend mode="normal" in2="effect1_backgroundBlur_508_4543" result="effect2_dropShadow_508_4543" />
                <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_508_4543" result="shape" />
              </filter>
            </defs>
          </svg>

        </span>
      </div>
    </div>
  );
};

export default Slider;
